const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class Conquistadors extends Tactic {
    constructor() {
        super(
            Age.Age2,
            TacticNames.Hussars,
            [0, 2, 0],
            "2 + I/II/III",
            {}
        )
    }
}

module.exports = Conquistadors;